import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { TABS } from '@containers/Apparel/Customers/CustomPricing/List/Tabs';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router';
import React from 'react';
import { routes$ as instantQuote$ } from '../InstantQuote/Router';

export const routes$ = {
    Create: AsyncPageRender(() => pageModule(import('./Create'))),
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),

    CustomPricingList: AsyncPageRender(() => pageModule(import('./CustomPricing/List'))),
    CustomPricingView: AsyncPageRender(() => pageModule(import('./CustomPricing/View'))),
    CustomQuestionnaireView: AsyncPageRender(() => pageModule(import('./Questionnaire/Questions'))),
};

function Router() {
    return (
        <>
            {redirects({
                '/customers/:customer/custom-pricing': ({ customer }) => `/customers/${customer}/custom-pricing/sku`,
                '/clients/:customer/edit': ({ customer }) => `/clients/${customer}/edit/account`,
                '/prices': () => `/prices/${TABS[0]}`,
            })}

            <Route name={'Customer.List'} exact path={'/clients/list'} component={ProtectedRoute(routes$.List)} />
            <Route name={'Customer.Create'} exact path={'/clients/create'} component={ProtectedRoute(routes$.Create)} />

            <Route
                name={'Customer.ByCustomer.View'}
                exact
                path={'/clients/:customer/view/:tab'}
                component={ProtectedRoute(routes$.View)}
            />
            <Route
                name={'Customer.ByCustomer.View'}
                exact
                path={'/clients/:customer/view'}
                component={ProtectedRoute(routes$.View)}
            />
            <Route
                name={'Customer.ByCustomer.Edit'}
                exact
                path={'/clients/:customer/edit/:tab'}
                component={ProtectedRoute(routes$.Edit)}
            />

            <Route
                name={'CustomPricing.List'}
                exact
                path={'/prices/:tab'}
                component={ProtectedRoute(routes$.CustomPricingList)}
            />
            <Route
                name={'CustomPricing.Customer'}
                exact
                path={'/customers/:customer/custom-pricing/:tab'}
                component={ProtectedRoute(routes$.CustomPricingView)}
            />

            <Route exact path={'/clients/instant-quotes'} component={ProtectedRoute(instantQuote$.ListAdmin)} />
            <Route
                exact
                path={'/clients/instant-quotes/:order'}
                component={ProtectedRoute(instantQuote$.ViewCustomer)}
            />

            <Route exact path={'/clients/questions'} component={ProtectedRoute(routes$.CustomQuestionnaireView)} />
        </>
    );
}

export default Router;
